import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { apiBoltOnsGet } from '../../api/api-bolt-ons';
import { TourTypeContext } from '../../contexts/tour-type-context';
import { FontAwesomeIcon, PageTitle, Table, TableCell, TableRow } from '../common';
import { listPageActions } from './page-actions';

const BoltOnList = () => {
    const [data, setData] = useState([]);
    const { displayType } = useParams();
    const { tourTypeId } = useContext(TourTypeContext);
    const [anyDisabled, setAnyDisabled] = useState(false);

    const LoadData = useCallback(async () => {
        setData(await apiBoltOnsGet(tourTypeId));
    }, [tourTypeId]);

    useEffect(() => {
        LoadData();
    }, [LoadData]);

    useEffect(() => {
        setAnyDisabled(data.filter((x) => x.isDisabled).length > 0);
    }, [data]);

    const boltOnsToDisplay = () => {
        if (displayType === 'disabled') {
            return data.filter((x) => x.isDisabled);
        } else {
            return data.filter((x) => !x.isDisabled);
        }
    };

    return (
        <div className="max-w-screen-lg my-2 sm:m-4 sm:rounded-lg shadow-md bg-white sm:px-4 py-4 md:mx-auto">
            <PageTitle title="Bolt-Ons" actions={listPageActions(displayType, anyDisabled)} />
            <Table>
                <thead>
                    <tr>
                        <TableCell text="Name" header />
                        <TableCell text="Category" header className="hidden md:table-cell" />
                        <TableCell text="When" header className="md:hidden" />
                        <TableCell text="Departing" header className="hidden md:table-cell" />
                        <TableCell text="Valid" header className="hidden md:table-cell" />
                        <TableCell text="Price" right header />
                        <TableCell text="" header />
                    </tr>
                </thead>

                <tbody>
                    {boltOnsToDisplay().map((item, key) => (
                        <TableRow key={key} rowNum={key}>
                            <TableCell className="tablecell-wrap-normal">
                                {item.boltOnName}
                                {item.isDisabled ? ' (Disabled)' : ''}
                                {item.boltOnCategoryName && (
                                    <div className="md:hidden">
                                        <FontAwesomeIcon icon="icons" /> {item.boltOnCategoryName}
                                    </div>
                                )}
                            </TableCell>
                            <TableCell className="hidden md:table-cell">{item.boltOnCategoryName}</TableCell>
                            <TableCell className="md:hidden">
                                {item.tourDisplay && (
                                    <div className="my-1">
                                        <FontAwesomeIcon icon="calendar-day fa-fw" />
                                        <span className="ml-2">{item.tourDisplay}</span>
                                    </div>
                                )}
                                {item.validDisplay && (
                                    <div className="my-1">
                                        <FontAwesomeIcon icon="th fa-fw" />
                                        <span className="ml-2">{item.validDisplay}</span>
                                    </div>
                                )}
                            </TableCell>
                            <TableCell className="hidden md:table-cell">
                                {item.tourDisplay && (
                                    <div className="my-1">
                                        <FontAwesomeIcon icon="calendar-day" />
                                        <span className="ml-2">{item.tourDisplay}</span>
                                    </div>
                                )}
                            </TableCell>
                            <TableCell className="hidden md:table-cell">
                                {item.validDisplay && (
                                    <div className="my-1">
                                        <FontAwesomeIcon icon="th" />
                                        <span className="ml-2">{item.validDisplay}</span>
                                    </div>
                                )}
                                {item.filterDisplay && (
                                    <div className="my-1">
                                        <FontAwesomeIcon icon="th-list" />
                                        <span className="ml-2">{item.filterDisplay}</span>
                                    </div>
                                )}
                            </TableCell>
                            <TableCell right>{item.priceDisplay}</TableCell>
                            <TableCell action>
                                <Link to={`/bolt-on/${item.id}`}>
                                    <FontAwesomeIcon icon="edit" title="Edit" />
                                </Link>
                            </TableCell>
                        </TableRow>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default BoltOnList;
